export default __webpack_public_path__ + "static/media/bariol_light-webfont.dc8fcee6.woff";